export const CHANNEL_LABELS = {
  PHONE: 'SMS',
  EMAIL: 'e-mail',
};

export const getChannelLabel = (contactType) =>
  CHANNEL_LABELS[contactType] || CHANNEL_LABELS.EMAIL;

export const buildSendSuccessMessage = (contact) =>
  `Enviamos um código de verificação por ${getChannelLabel(
    contact?.contactType
  )} para ${contact?.contact}`;

export const buildResendSuccessMessage = (contact) =>
  `Reenviamos um código de verificação por ${getChannelLabel(
    contact?.contactType
  )} para ${contact?.contact}`;

export const SEND_FAILURE_MESSAGE =
  'Não foi possível enviar o código. Tente novamente ou escolha o envio por outro canal.';

export const INVALID_CODE_MESSAGE =
  'O código informado é inválido. Verifique e tente novamente.';

export const EXPIRED_CODE_MESSAGE =
  'Este código expirou. Solicite um novo código para continuar.';

export const GENERIC_ERROR_MESSAGE = 'Ocorreu um erro interno na aplicação';
